export const footerImages = {
  1: require("./eu.png"),
  2: require("./italia.png"),
  3: require("./Logo.png"),
  4: require("./fesr.png"),
  5: require("./stringa_fondoscuro.png"),
  6: require("./stringa_fondochiaro.png"),
  7: require("./stringaFESR_2014-2020.png"),
};
